export const HNL_CENTRE: [number, number] = [21.318691, -157.922407] // Elevation: 4.0m
